class MegaMenuUnifiedController extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details.mega-menu--unified');
    if (!this.details) return;

    this.panel = this.details.querySelector('.mega-menu__content');
    this.headerWrapper = document.querySelector('.header-wrapper');
    this.stickyHeader = document.querySelector('sticky-header.header-wrapper') || this.headerWrapper;

    this._leaveTimer = null;
    this._onEnter = this._onEnter.bind(this);
    this._onLeave = this._onLeave.bind(this);
    this._onPanelEnter = this._onPanelEnter.bind(this);
    this._onToggle = this._onToggle.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

    this.querySelectorAll('.mega-unified__trigger-li').forEach((li) => {
      li.addEventListener('mouseenter', this._onEnter);
      li.addEventListener('focusin', this._onEnter);
    });

    this.addEventListener('mouseleave', this._onLeave);
    if (this.panel) {
      this.panel.addEventListener('mouseenter', this._onPanelEnter);
      this.panel.addEventListener('mouseleave', this._onLeave);
    }

    this.details.addEventListener('toggle', this._onToggle);
    document.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeyDown);
    if (this.details) {
      this.details.removeEventListener('toggle', this._onToggle);
    }
    this._clearLeaveTimer();
  }

  _isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  _onKeyDown(e) {
    if (e.key !== 'Escape') return;
    if (!this.details?.hasAttribute('open')) return;
    this.close();
  }

  _clearLeaveTimer() {
    if (this._leaveTimer) {
      clearTimeout(this._leaveTimer);
      this._leaveTimer = null;
    }
  }

  _onEnter() {
    if (!this._isDesktop()) return;
    this._clearLeaveTimer();
    this.open();
  }

  _onPanelEnter() {
    if (!this._isDesktop()) return;
    this._clearLeaveTimer();
  }

  _onLeave(event) {
    if (!this._isDesktop()) return;
    const rt = event.relatedTarget;
    if (rt && this.contains(rt)) return;

    this._leaveTimer = window.setTimeout(() => {
      this._leaveTimer = null;
      if (!this.matches(':hover')) this.close();
      this.syncLuxuryNavPanel();
    }, 220);
  }

  _onToggle() {
    this.syncLuxuryNavPanel();
    if (this.details?.hasAttribute('open')) {
      this._refreshHeaderBottom();
    }
  }

  open() {
    if (!this.details) return;
    this.details.setAttribute('open', '');
    this._refreshHeaderBottom();
    this.syncLuxuryNavPanel();
  }

  close() {
    if (!this.details) return;
    this.details.removeAttribute('open');
    this.syncLuxuryNavPanel();
  }

  _refreshHeaderBottom() {
    if (!this.headerWrapper?.classList.contains('header-wrapper--luxury-nav-reveal')) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.headerWrapper.getBoundingClientRect().bottom)}px`
    );
  }

  syncLuxuryNavPanel() {
    if (!this.headerWrapper) return;

    if (!this.headerWrapper.classList.contains('header-wrapper--luxury-nav-reveal')) {
      this.headerWrapper.classList.remove('header-wrapper--nav-disclosure-open');
      if (this.stickyHeader) this.stickyHeader.preventHide = false;
      return;
    }

    const anyTraditional = this.headerWrapper.querySelector(
      '.header__inline-menu > ul.list-menu--inline > li > header-menu > details[open]'
    );
    const unifiedOpen = Boolean(this.details?.hasAttribute('open'));
    const open = Boolean(anyTraditional || unifiedOpen);

    this.headerWrapper.classList.toggle('header-wrapper--nav-disclosure-open', open);
    if (this.stickyHeader) {
      this.stickyHeader.preventHide = open;
    }
  }
}

customElements.define('mega-menu-unified-controller', MegaMenuUnifiedController);
